import { CmsMeta } from '../cmsMeta';
import './CmsImage.css';

type CmsImageParams = {
	url: string;
	description: string;
	maxWidth?: number;
	className?: string;
};

export const CmsImage = ({ url, description, maxWidth, className }: CmsImageParams): JSX.Element => {
	const isAbsoluteUrl = /^([a-z][a-z0-9+.-]*:)?\/\//i.test(url) || url.startsWith('/');
	const src = isAbsoluteUrl ? url : `/images/${url.replace(/^\/+/, '')}`;

	return (
		<img
			className={`cms-image ${className || ''}`}
			src={src}
			alt={description}
			style={maxWidth ? { maxWidth: `${maxWidth}px` } : undefined}
		/>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A single image in the flow of the page. `description` is its alt text, so write what the image shows rather than what it is called.',
	example: [
		'CmsImage',
		{
			index: 5,
			url: 'https://cdn.ondio.com/assets/6b99f8c3c006476ba6056703215fd049.png',
			maxWidth: '636',
			description: 'Worky -> Ondio',
		},
	],
};
